export default {
  configuration_preview_title: "Previsualización de Configuración",
  configuration_preview_success_message: "Configuración guardada exitosamente",
  configuration_preview_error_message: "No se ha podido guardar la configuración debido a un error",
  configuration_preview_save_changes: "Guardar Cambios",
}
